import React, { Component } from 'react'

import { ArvoreSelecionavelObj } from 'scorpion-core'



export default class ArvorePermissoesGeral extends Component {




  render() {


    return (
      <ArvoreSelecionavelObj {...this.props} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/permissoes/components/ArvorePermissoesGeral/ArvorePermissoesGeral.js